import { render } from "./FPluginPath.vue?vue&type=template&id=5bf4fa72&scoped=true"
import script from "./FPluginPath.vue?vue&type=script&lang=js"
export * from "./FPluginPath.vue?vue&type=script&lang=js"

import "./FPluginPath.vue?vue&type=style&index=0&id=5bf4fa72&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf4fa72"]])

export default __exports__